var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEmailIconFl = function SvgEmailIconFl(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#emailIcon_fl_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.99 0H1.01C.45 0 0 .45 0 1.01V11c0 .56.45 1.01 1.01 1.01H15c.56 0 1.01-.45 1.01-1.01V1.01C16.01.45 15.56 0 15 0h-.01ZM8 6.28 1.96 1.1h12.08L8 6.28Zm-2.08-.35L1.1 10.07V1.8l4.82 4.14v-.01Zm.84.73L8 7.73l1.24-1.07 4.95 4.25H1.8l4.95-4.25h.01Zm3.32-.73L14.9 1.8v8.27l-4.82-4.14Z",
    fill: "#000"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "emailIcon_fl_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v12H0z"
  })))));
};
export default SvgEmailIconFl;